import { Footer } from "../../Components/Footer";
import { Header } from "../../Components/Header";
import "./HonorCode.css";
export const HonorCode = () => {
  return (
    <>
      <Header />
      <main>
        <div className="container-fluid container-main">
          <div className="row px-5 px-md-2 mt-5">
            <div className="col-lg-6 px-5 ">
              <h2>The Honor Code</h2>
              <p>
                Our honor code reflects our commitment to academic honesty and
                high standards. Our academic values and culture reflect our
                company's professionalism. Our main purpose is to deliver
                personalized guidance to students all over the world. We make
                every effort to assist students regardless of their financial
                situation, ethnicity, social standing, or other irrelevant
                characteristics.
              </p>
            </div>
            <div className="col-lg-6 text-center">
              <img src="/images/honorcode.webp" alt="" />
            </div>
          </div>
        </div>
        <div className="container-fluid container-info mt-5 px-5">
          <div className="text-section text-center mt-5px-sm-1">
            <h3>Services Code of Conduct</h3>
            <p>
              Our writing service operates within ethical boundaries and adheres
              to professional standards. We do not condone any form of
              dishonesty, including plagiarism, fraud, or unethical behavior, in
              our work. Integrity and authenticity are paramount in all our
              endeavors.
            </p>
          </div>
          {/* Cards of services section */}
          <div className="cards p-4">
            <div className="row">
              <div className="col-lg-6 mt-3">
                <div className="card" style={{}}>
                  <div className="card-body">
                    <h5 className="card-title">Business Writing</h5>
                    <p className="card-text">
                      We provide professional business writing services,
                      ensuring that all content is original, accurate, and
                      tailored to meet your business needs.Crafting compelling
                      and professional tailored to your needs.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mt-3">
                <div className="card" style={{}}>
                  <div className="card-body">
                    <h5 className="card-title">Academic Writing</h5>
                    <p className="card-text">
                      Our academic writing services are conducted with academic
                      integrity in mind. We do not engage in any form of
                      academic, such as plagiarism or cheating, and ensure that
                      all work is scholarly and properly referenced.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mt-3">
                <div className="card" style={{}}>
                  <div className="card-body">
                    <h5 className="card-title">Content Writing</h5>
                    <p className="card-text">
                      For engaging and informative content, our content writing
                      services deliver high-quality, original content tailored
                      to your specific audience and requirements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Policies for Writing Services */}
        <div className="container-fluid">
          <div className="text-container px-5 mt-3">
            <h4>Business Policy of Serve Biznes for Academic Writing:</h4>
            <p>
              Serve Biznes is a reputable and well-known writing service
              catering to academic needs. We boast a diverse team of experienced
              writers and subject matter experts committed to assisting students
              while strictly adhering to academic standards and regulations. We
              refrain from providing any form of assistance that promotes
              academic dishonesty or fraud. Our commitment is to uphold the
              highest ethical standards while aiding students. Additionally, any
              team member found violating academic policies or laws will face
              immediate repercussions, including termination.
            </p>
            <h4>Open Letter to Students and Prospective Clients:</h4>
            <p>
              Serve Biznes is dedicated to helping students achieve academic
              success through our writing services. Our goal is to provide
              students with affordable and effective learning support by
              delivering sample solutions promptly and professionally. However,
              we strongly oppose the submission of our sample solutions as
              original work and prohibit their sale or unauthorized use for
              unethical purposes.
            </p>
            <h4>Open Letter to Educators and Institutions:</h4>
            <p>
              Serve Biznes values the partnership with educators and
              institutions in fostering student learning. We are committed to
              providing high-quality, cost-effective assistance while complying
              with academic rules and guidelines. We urge educators to notify us
              immediately of any breaches of academic integrity involving our
              services, and we pledge to take swift action against any
              misconduct.
            </p>
            <h4>Open Letter to Businesses and Organizations:</h4>
            <p>
              Serve Biznes extends its services beyond individuals to cater to
              the needs of businesses and organizations. We offer a range of
              writing services, including formal documents, technical papers,
              and content creation, at competitive prices. However, we strictly
              prohibit the use of our services for deceptive or fraudulent
              purposes, and we expect all clients to adhere to legal and ethical
              standards.
            </p>
            <h4>Open Letter to Our Writers and Tutors:</h4>
            <p>
              Serve Biznes is committed to upholding academic integrity through
              the conduct of our team members. We provide opportunities for
              professional growth while expecting adherence to academic
              regulations and policies. Our team members are prohibited from
              engaging in any form of academic dishonesty or illegal activity,
              and strict measures will be taken against violators.
            </p>
            <h4>List of Tasks That Serve Biznes Never Accepts:</h4>
            <p>
              Serve Biznes maintains a strong stance against academic dishonesty
              and unethical practices. We do not accept orders that involve
              manipulation of data, creation of fake documents, impersonation,
              plagiarism, or any activity that promotes academic fraud. Clients
              are urged to familiarize themselves with our policies and refrain
              from requesting such tasks.
            </p>
            <h4>Academic Integrity:</h4>
            <p>
              Serve Biznes condemns all forms of academic cheating and
              plagiarism. We encourage reporting any instances of academic
              dishonesty involving our services for prompt action.
            </p>
            <h4>Prohibition of Hate Speech:</h4>
            <p>
              Serve Biznes strictly prohibits the creation of content promoting
              violence, hate speech, or communal conflicts. Clients are
              encouraged to report any such material for immediate action.
            </p>
            <h4>Privacy Policy Compliance:</h4>
            <p>
              Serve Biznes adheres to strict privacy policies to safeguard
              customer information. Any breaches of our privacy policy should be
              reported for investigation and action.
            </p>
            <h4>Prevention of Illegal Activities:</h4>
            <p>
              Serve Biznes does not support any form of illegal activity and
              encourages clients to report any such instances for appropriate
              measures.
            </p>
            <h4>Transparency in Payments:</h4>
            <p>
              Serve Biznes conducts all financial transactions through secure
              channels and prohibits under-the-table commissions. Any attempts
              to solicit unauthorized payments should be reported for immediate
              action.
            </p>
          </div>
        </div>
        <div className="container px-5 px-md-2 text-center mt-5">
          <h2 className="px-5">
            Noticed Any Activity That Goes Against Our Honor
          </h2>
          <h2>Code?</h2>
          <p>
            We encourage our clients to report any illegal activity which
            violates our honor code. If you
          </p>
          <p>
            find someone from our team or a customer indulging in malicious
            activities, please submit a report to us
          </p>
          <p>
            through our support team or via email. We would ensure that strict
            action is taken against the parties
          </p>
          <p>involved:</p>
        </div>
        {/* Checkboxes and Comment Form */}
        <div className="container honor_code">
          <div className="row">
            <div className="col-lg-6">
              <div className="row">
                <div className="checkBoxes mb-3 position-relative d-flex">
                  <input
                    className="form-check-input mychBox mx-3 mt-3 position-absolute"
                    type="checkbox"
                    name="writing"
                    defaultValue="Business Writing"
                    id="businessWritingCheckbox"
                  />
                  <label
                    className="form-control checkLabel py-3 pe-3 ps-55"
                    htmlFor="businessWritingCheckbox"
                  >
                    <div className="text">
                      <h5>Business Writing</h5>
                      <p className="mb-0">
                        We ensure originality and professionalism in all
                        business writing projects, avoiding any form of academic
                        dishonesty or fraud.
                      </p>
                    </div>
                  </label>
                </div>
                <div className="checkBoxes mb-3 position-relative d-flex">
                  <input
                    className="form-check-input mychBox mx-3 mt-3 position-absolute"
                    type="checkbox"
                    name="writing"
                    defaultValue="Academic Writing"
                    id="academicWritingCheckbox"
                  />
                  <label
                    className="form-control checkLabel py-3 pe-3 ps-55"
                    htmlFor="academicWritingCheckbox"
                  >
                    <div className="text">
                      <h5>Academic Writing</h5>
                      <p className="mb-0">
                        We strictly adhere to academic integrity, ensuring that
                        all academic writing services are scholarly, properly
                        referenced, and free from plagiarism.
                      </p>
                    </div>
                  </label>
                </div>
                <div className="checkBoxes mb-3 position-relative d-flex">
                  <input
                    className="form-check-input mychBox mx-3 mt-3 position-absolute"
                    type="checkbox"
                    name="writing"
                    defaultValue="Content Writing"
                    id="contentWritingCheckbox"
                  />
                  <label
                    className="form-control checkLabel py-3 pe-3 ps-55"
                    htmlFor="contentWritingCheckbox"
                  >
                    <div className="text">
                      <h5>Content Writing</h5>
                      <p className="mb-0">
                        For engaging and informative content, our content
                        writing services deliver high-quality, original content
                        tailored to your specific audience and requirements.
                      </p>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="container-comment">
                <form action="action_page.php">
                  <label htmlFor="e-mail">E-mail</label>
                  <input
                    type="e-mail"
                    id="e-mail"
                    name="email"
                    placeholder="Your E-mail.."
                  />
                  <label htmlFor="comment">Comment</label>
                  <textarea
                    id="comment"
                    name="comment"
                    placeholder="Write something.."
                    style={{ height: 200 }}
                    defaultValue={""}
                  />
                  <input type="submit" defaultValue="Submit" />
                </form>
              </div>
              <div className="checkBoxes mb-3 position-relative d-flex mt-3">
                <input
                  className="form-check-input mychBox mx-3 mt-3 position-absolute"
                  type="checkbox"
                  name="writing"
                  defaultValue="Others"
                  id="othersCheckbox"
                />
                <label
                  className="form-control checkLabel py-3 pe-3 ps-55"
                  htmlFor="othersCheckbox"
                >
                  <div className="text">
                    <h5>Others</h5>
                    <p className="mb-0">
                      We request our clients and customers to report to us if
                      any of our writers or tutors asks you for any extra
                      payment or commissions. We would take strict action
                      against team members involved in any ill-financial
                      practices.
                    </p>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};
